// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2XqFC","card":"Cards_card__1ak5A","infected":"Cards_infected__bZ078","recovered":"Cards_recovered__1wTBM","deaths":"Cards_deaths__1YvrA"};